/**
 * Orca Events route — eagerly registers the route + `beforeLoad` SSR loader but
 * defers the component + atom imports via `.lazy.tsx`, so the orca-admin chunk
 * stays out of the bundle for non-admins on every other route. The page mounts
 * the v5 orcaloops frame (OL-396), whose sheet arrives through `head()` here as
 * a `?url` link.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { orcaEventsBeforeLoad } from "~/lib/orca-ssr.ts";
import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * The route's `head()`: the orcaloops frame's sheet. Extracted so it is
 * unit-testable without the route machinery.
 *
 * @since 1.0.0
 */
export const eventsHead = () => ({ links: orcaloopsStylesheetLinks });

export const Route = createFileRoute("/orca/events")({
  beforeLoad: orcaEventsBeforeLoad,
  head: eventsHead,
});
